import script from "./after-login-gateway.vue?vue&type=script&setup=true&lang=js"
export * from "./after-login-gateway.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__